import { PLATFORM } from 'aurelia-framework';
import { roles } from 'routes';

export const pens_routes = [
  {
    route: ['pens/offers'],
    name: 'pens-offers-view',
    settings: { roles: [roles.pensSales, roles.pensAdministrator], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pens-offers/pens-offers-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'pens.offer',
    route_base: 'pens/offers',
    section: 'pens',
  },
  {
    route: ['pen-offer/:penOfferId/pen/:penId'],
    name: 'pen-offer-view',
    settings: { roles: [roles.pensSales, roles.pensAdministrator], searcheable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pens-offers/pen-offer-view') },
      side: { moduleId: null },
    },
  },
  {
    route: ['pen-offer/:Id/pen/:PenId/edit'],
    name: 'pen-offer-edit',
    settings: { roles: [roles.pensSales, roles.pensAdministrator], searcheable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pens-offers/pen-offer-edit') },
      side: { moduleId: null },
    },
  },
  {
    route: ['pen-offer/:penOfferId/pen/:penId/convert'],
    name: 'pen-offer-create-order',
    settings: { roles: [roles.pensSales, roles.pensAdministrator], searcheable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pens-offers/pen-offer-create-order') },
      side: { moduleId: null },
    },
  },
  {
    route: ['pens/orders'],
    name: 'pen-orders-view',
    settings: { roles: [roles.pensSales, roles.pensProduction, roles.pensProductionSupervisor, roles.pensAdministrator], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pens-orders/pen-orders-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'pens.orders',
    route_base: 'pens/orders',
    section: 'pens',
  },
  {
    route: ['pen-order/:penOrderId/pen/:penId'],
    name: 'pen-order-view',
    settings: { roles: [roles.pensSales, roles.pensProduction, roles.pensProductionSupervisor, roles.pensAdministrator], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pens-orders/pen-order-view') },
      side: { moduleId: null },
    },
  },
  {
    route: ['pen/:id'],
    name: 'pen-view',
    settings: { roles: [roles.pensSales, roles.pensProduction, roles.pensProductionSupervisor, roles.pensAdministrator], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/pens/pen/pen-view') },
      side: { moduleId: null },
    },
  },
];
